

















































































































































import { defineComponent } from '@vue/composition-api'
import { mask } from 'vue-the-mask'
import { crudEditMixin } from '@/utils/mixins/crudEditMixin'
import {
  autoAssignController,
  getMessengers,
} from '@/api/Remittances/remittances.api'
import vRules from '@/utils/vRules'
import { Region } from '@/utils/interfaces'
import { getRegions } from '@/api/Address/address'
import Autocomplete from '@/components/Autocomplete.vue'
import CreateDialog from '@/components/CreateDialog.vue'
import { DeliveryCurrenciesEnum } from '@/utils/interfaces/remittance.interface'
import ActionButton from '@/components/ActionButton.vue'
import moment from 'moment'

export default defineComponent({
  components: { CreateDialog, Autocomplete, ActionButton },
  directives: { mask },
  mixins: [
    crudEditMixin(
      {
        regions: [],
        region: 0,
        rate: 1,
        messenger: '',
        delivery_currency: 'CUP',
        commission_currency: 'CUP',
        force_commission: false,
        ranges: [
          {
            min: '0',
            max: '100',
            commission: '0',
            id: `${moment().unix()}${moment().milliseconds()}`,
          },
        ],
      },
      autoAssignController.createOrUpdateJson,
    ),
  ],
  data() {
    return {
      vRules,
      regions: [] as Region[],
      getMessengers,
      deliveryCurrencies: Object.values(DeliveryCurrenciesEnum),
      headers: ['min', 'max', 'commission', 'actions'].map(item => ({
        text: this.$t(item),
        value: item,
      })),
    }
  },
  methods: {
    onAdd() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.crud.ranges.push({
        min: '0',
        max: '100',
        commission: '0',
        cup_commission: true,
        id: `${moment().unix()}${moment().milliseconds()}`,
      })
    },
    onDelete(item: any) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const index = this.crud.ranges.indexOf(item)
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (index > -1) this.crud.ranges.splice(index, 1)
    },
  },
  async mounted() {
    const response = await getRegions({ country__name: 'Cuba', limit: 20 })
    this.regions = response.data.results
  },
})
